export default "__VITE_ASSET__Cpo3UBY2__"